/**
 * Interface for StillImageBackground background images config
 */
import { Sprite, Point, Graphics, Container, BLEND_MODES } from "pixi.js";
import { Power2, Power3, Power0, gsap, Back } from 'gsap';

import { StateHandler } from "../../../core/utils/StateHandler";
import { StageLayer } from '@nolimitcity/slot-launcher/bin/StageLayer';
import { SpinePlayer } from "../../../core/displayobject/SpinePlayer";
import { SanQuentin2 } from "../../SanQuentin2";
import { GameAssets } from "../../config/texture/GameAssets";
import { ResizeHelper } from "../../../core/utils/ResizeHelper";
import { Helper } from "../../../core/utils/Helper";

enum BGAnimations { idle = "idle", transform_in = "transform_in", intro = "game intro",
    intro_short = "game intro_short" }
enum FS_BGAnimations { idle = "idle", transform_in = "transform_in" }

export class BgSpineMode extends StateHandler {

    public static readonly NORMAL: string = "BG_Main";
    public static readonly NORMAL_IDLE: string = "BG_Main_Idle";
    public static readonly NORMAL_TO_FS: string = "BG_Main_To_FS";
    public static readonly FS_TO_NORMAL: string = "BG_FS_To_Main";
    public static readonly FS_IDLE: string = "BG_FS";
}

export class SanBackground extends PIXI.Container implements StageLayer {

    private readonly WIDTH:number = 1680;
    private readonly HEIGHT:number = 900;

    protected bg_spine_portrait: SpinePlayer;

    private bg_spine: SpinePlayer;
    private bg_RedLight: SpinePlayer;
    private bg_fs: SpinePlayer;
    _bgGFX: PIXI.Graphics;

    private isFSMode:boolean;

    constructor() {
        super();
        this.buttonMode = false;
        this.initAnimations();
        
    }
    
    protected initAnimations(): void {

        // this.pivot.x = -55;

        this.bg_spine = this.addChild(new SpinePlayer("BG_base"));
        this.bg_spine.position.set(410, 280);
        this.bg_spine.play({ animation: BGAnimations.idle, loop: true });

        this.bg_spine_portrait = this.addChild(new SpinePlayer("tower"));
        this.bg_spine_portrait.position.set(360, -140);
        this.bg_spine_portrait.play({ animation: "animation", loop: true });
        
        this.bg_fs = this.addChild(new SpinePlayer("bg_fs"));
        this.bg_fs.position.set(340, 260);


        this.bg_RedLight = this.addChild(new SpinePlayer("red light"));
        this.bg_RedLight.zIndex = 500;
        this.bg_RedLight.alpha = 0;
        this.bg_RedLight.position.set(360,360);
        
        this.createGraphics();
        this.onResize();
    }

    public onIntro():gsap.core.Timeline{
        return this.bg_spine.play({
            animation: BGAnimations.intro_short, showOnEnd: true, onComplete: () => {
                this.bg_spine.play({ animation: BGAnimations.idle, loop: true });
            }
        });;
    }

    public onRestore(isFS:boolean){
        this.isFSMode = true;
        this.bg_spine.stop(true);
        this.bg_fs.play({ animation: FS_BGAnimations.idle, loop: true })
    }

    private spTl:gsap.core.Timeline;
    public triggerTransition(toFS: boolean): number {
        this.isFSMode = toFS;
        this.spTl = Helper.setTimeline(this.spTl,undefined,true);

        if (toFS) {
            this.spTl.add(this.bg_spine.play({
                    animation: BGAnimations.transform_in, showOnEnd: false, onComplete: () => {
                    this.bg_spine_portrait.visible = false;
                }
            }));
            this.spTl.add(this.bg_fs.play({
                animation: FS_BGAnimations.transform_in, showOnEnd: true, onComplete: () => {
                    this.bg_fs.play({ animation: FS_BGAnimations.idle, loop: true });
                }
            }));
            let longestAnim = this.bg_spine.fetchDuration(BGAnimations.transform_in);// Math.max(this.bg_spine.fetchDuration(BGAnimations.transform_in), this.bg_fs.fetchDuration(FS_BGAnimations.transform_fs));
            return longestAnim;  

        }else{
            this.spTl.add(this.bg_spine.play({animation: BGAnimations.idle, loop:true}),0);
            this.bg_spine_portrait.visible = true;
            this.spTl.to(this.bg_fs,{alpha:0,duration:1},0).eventCallback("onComplete",() =>{ 
                this.bg_fs.visible = false; this.bg_spine_portrait.visible = true;
                this.bg_fs.alpha = 1;
            })

            this.spTl.fromTo(this.bg_spine,{alpha:0},{alpha:1,duration:1},0);
            return 1;
        }
    }

    showRedLight(val:boolean):void{
        if(val && !this.bg_RedLight.isPlaying){
            this.bg_RedLight.play({animation:"idle",loop:true});
            gsap.to(this.bg_RedLight,{alpha:1, duration:1});
        }else if(this.bg_RedLight.isPlaying){
            gsap.timeline().to(this.bg_RedLight,{alpha:0, duration:1}).add(() =>{
                this.bg_RedLight.stop();
            })
        }
    }

    setBgGFX(alpha:number,durr:number){
        gsap.to(this._bgGFX, { alpha: alpha, duration: durr });
    }

    private createGraphics():void{
        this._bgGFX = this.addChild(new PIXI.Graphics());
        this._bgGFX.alpha = 0;

        this._bgGFX.beginFill( 0x000000, 1);
        this._bgGFX.drawRect(-this.WIDTH/2,-this.HEIGHT/2,this.WIDTH*2, this.HEIGHT*2);
        this._bgGFX.endFill();
    }

    public onResize(): void {
        this.bg_spine_portrait.visible = !this.isFSMode && !ResizeHelper.isLandscape;
    }
}